import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppServerAPI, DialogService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { Station } from '../../../client/model/station';
import { Transport } from '../../../common/model/transport.model';
import { TransportStationAssignment } from '../../../widgets/control/sac-client/model/sac-client.model';

@Component({
  selector: 'app-resend-message-action',
  templateUrl: './resend-message-action.component.html',
  styleUrls: ['./resend-message-action.component.scss']
})
export class ResendMessageActionComponent {

  @Input() disabled = false;

  @Input() transport: Transport;

  @Input() station: Station;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter();

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI
  ) { }

  clickButton() {


    this.dialogService.showConfirm(
      'tmc-yard.sac-client.ui.call-transport-to-station.confirm-dialog.title',
      'tmc-yard.sac-client.ui.call-transport-to-station.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {

      if (confirm) {

        const assignment = new TransportStationAssignment();
        assignment.transport = { id: this.transport.id };
        assignment.station = { id: this.station.id };

        this.appServerAPI.execute<any[]>('/client/control/sac-client/call-transport', assignment).subscribe(
          response => {
            this.onChange.next();
          },
          error => {
            console.error(error);
          }
        );

      }

    });

  }
}

